import { render, staticRenderFns } from "./logisticsEdit.vue?vue&type=template&id=e6ef41c4&"
import script from "./logisticsEdit.vue?vue&type=script&lang=js&"
export * from "./logisticsEdit.vue?vue&type=script&lang=js&"
import style0 from "./logisticsEdit.vue?vue&type=style&index=0&id=e6ef41c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports